import React, { useState } from "react";
import { useRefinementList } from "react-instantsearch";

function CustomRefinementList({ title, attribute }) {
    const [isOpen, setIsOpen] = useState(true);
    const [query, setQuery] = useState("");

    const {
        items,
        refine,
        searchForItems,
        canToggleShowMore,
        isShowingMore,
        toggleShowMore
    } = useRefinementList({
        attribute,
        sortBy: ["name:asc"],
        limit: 20,
        showMore: true,
        showMoreLimit: 300,
    });

    const handleSearch = (e) => {
        const value = e.target.value;
        setQuery(value);
        searchForItems(value); // 🔥 Algolia search dans les facettes
    };

    return (
        <div className="mb-3 border" style={{marginLeft: "10px", marginRight: "0.5rem"}}>
            {/* HEADER */}
            <div
                className="p-2 bg-light d-flex justify-content-between align-items-center"
                style={{ cursor: "pointer" }}
                onClick={() => setIsOpen(!isOpen)}
            >
                <span>{title}</span>
                <span>{isOpen ? "▼" : "▶"}</span>
            </div>

            {/* CONTENT */}
            {isOpen && (
                <div className="p-2">

                    {/* 🔍 SEARCH INPUT */}
                    <input
                        type="text"
                        className="form-control mb-2"
                        placeholder={`Rechercher ${title.toLowerCase()}`}
                        value={query}
                        onChange={handleSearch}
                    />

                    {/* LIST */}
                    {items.map((item) => (
                        <div key={item.value}>
                            <label>
                                <input
                                    type="checkbox"
                                    checked={item.isRefined}
                                    onChange={() => refine(item.value)}
                                />
                                {item.label} <span>({item.count})</span>
                            </label>
                        </div>
                    ))}

                    {/* 🔥 VOIR PLUS */}
                    {canToggleShowMore && (
                        <button
                            className="btn btn-sm btn-link mt-2"
                            onClick={toggleShowMore}
                        >
                            {isShowingMore ? "Voir moins" : "En savoir plus"}
                        </button>
                    )}
                </div>
            )}
        </div>
    );
}

export default CustomRefinementList;